import { MutationTuple, useMutation } from '@apollo/client';
import {
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables,
} from '__generated__/graphql';
import { UPDATE_USER_SETTINGS } from 'graphql/users/mutations/updateUserSettings.gql';

export default function useUpdateUserSettingsMutation(): MutationTuple<
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables
> {
  return useMutation(UPDATE_USER_SETTINGS);
}
